<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- E-mail verification -->
      <b-card class="mb-0">
        <!-- logo -->
        <b-link class="brand-logo">
          <h2 class="brand-text text-primary ml-1">
            RättVisat
          </h2>
        </b-link>
        <div v-if="emailVerified && calledDatabase">
          <!-- om verifieringen lyckas.. -->
          <div class="text-center">
            <span class="text-success" style="font-size: 4rem;"
              ><i class="fas fa-check-circle"></i
            ></span>
          </div>
          <b-card-title class="mb-1 text-center">
            Mailadress verfierad
          </b-card-title>

          <b-card-text class="mb-2 text-center">
            <p>
              Tack! Din mailadress är nu verifierad och ditt konto har
              aktiverats 😃👍
            </p>
            <p>Välkommen att logga in!</p>
          </b-card-text>
          <b-button
            variant="primary"
            @click="$router.push({ name: 'login' })"
            block
          >
            Logga in
          </b-button>
        </div>
        <div v-else-if="calledDatabase">
          <!-- ...annars -->
          <div class="text-center">
            <span class="text-danger" style="font-size: 4rem;"
              ><i class="fas fa-times-circle"></i
            ></span>
          </div>
          <b-card-title class="mb-1 text-center">
            Verifieringen misslyckades
          </b-card-title>

          <b-card-text class="mb-2 text-center">
            <p>Ajdå! Verifieringen misslyckades tyvärr...😖</p>
            <p>
              Klicka på knappen nedan så skickar vi ut en ny länk till dig! 😊👍
            </p>
          </b-card-text>
          <b-button variant="primary" @click="resendVerification()" block>
            Skicka ny länk
          </b-button>
        </div>
      </b-card>
      <!-- /E-mail verification -->
    </div>
  </div>
</template>

<script>
import { BCard, BCardTitle, BCardText, BLink, BButton } from "bootstrap-vue";
import userAccountService from "@/services/user-account.service";
import mailService from "@/services/mail.service";

export default {
  components: {
    BCard,
    BButton,
    BCardTitle,
    BCardText,
    BLink,
  },
  props: {
    code: String,
  },
  data() {
    return {
      verificationCode: String,
      userId: Number,
      emailVerified: false,
      calledDatabase: false,
    };
  },
  mounted() {
    this.$nextTick(function() {
      if (!this.code) this.$router.push("/error-404");
      else {
        this.userId = this.code.split("-")[0];
        this.verificationCode = this.code.substring(this.userId.length + 1);
        this.verifyEmail();
      }
    });
  },
  computed: {},
  methods: {
    verifyEmail: function() {
      userAccountService
        .verifyEmail(this.verificationCode)
        .then((res) => {
          if (res.status == 200) {
            this.emailVerified = true;
          }
          this.calledDatabase = true;
        })
        .catch(() => {
          this.calledDatabase = true;
        });
    },
    resendVerification() {
      //Send new verification e-mail then...
      userAccountService
        .initiateEmailVerification(null, this.userId)
        .then((res) => {
          const substituteData = {
            First_Name: res.data.first_name,
            Last_Name: res.data.last_name,
            Email_Verification_Code: res.data.id + "-" + res.data.reset_token,
          };
          if (!res.data) {
            throw "User could not be found";
          }

          mailService
            .sendEmail(
              "email_verification",
              res.data.email,
              substituteData,
              false
            )
            .then(() => {
              this.$swal({
                title: "Ny länk skickad",
                text:
                  "Tack! Vi har nu skickat en ny verifieringslänk till din mailadress 😃👍",
                icon: "success",
                showCancelButton: false,
                confirmButtonText: "Ok",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              }).then((result) => {
                if (result.value) {
                  this.$router.push({ name: "login" });
                }
              });
            });
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
